<template>
  <Toolbar class="mb-4 md:w-11">
    <template #start>
      <div class="flex-column align-items-center">
        <div class="flex flex-row">
          <div class="vacation-summary">
            <p class="summary-item">
              <strong>{{ vacationBalance }}</strong> días disponibles.
            </p>
          </div>
          <InfoButton :message="infoMessage" />
        </div>
      </div>
    </template>
    <template #end>
      <Button
        label="Nueva solicitud"
        icon="pi pi-plus"
        severity="primary"
        class="mr-2 font-semibold text-sm"
        @click="emit('new-request')"
      />
    </template>
  </Toolbar>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import Toolbar from 'primevue/toolbar'
  import Button from 'primevue/button'
  import InfoButton from '@/shared/components/InfoButton.vue'

  const props = defineProps<{
    vacationBalance: number | string
    infoHint?: string
  }>()

  const emit = defineEmits<{
    (event: 'new-request'): void
  }>()

  const infoMessage = computed(
    () =>
      props.infoHint ??
      'El saldo será actualizado una vez que las vacaciones sean procesadas en el sistema de nomina'
  )
</script>
